import revive_payload_client_4sVQNw7RlN from "/app/template1/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/template1/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/template1/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/app/template1/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/app/template1/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/template1/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/template1/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/template1/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/app/template1/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/app/template1/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/template1/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import nuxt_plugin_6wEQMY3tee from "/app/template1/node_modules/nuxt-delay-hydration/dist/runtime/nuxt-plugin.js";
import titles_m9SjywKgWm from "/app/template1/node_modules/@nuxtjs/seo/dist/runtime/nuxt/plugin/titles.mjs";
import defaults_SCHuOseEny from "/app/template1/node_modules/@nuxtjs/seo/dist/runtime/nuxt/plugin/defaults.mjs";
import plugin_UC48QI1yOB from "/app/template1/node_modules/@hypernym/nuxt-anime/dist/runtime/plugin.mjs";
import i18n_yfWm7jX06p from "/app/template1/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import components_client_ZB1W0EeH0E from "/app/template1/node_modules/nuxt-swiper/dist/runtime/plugins/components.client.js";
import clickOutside_C8jIyDRU4O from "/app/template1/plugins/clickOutside.js";
import v_no_right_click_FHwnEQbgDi from "/app/template1/plugins/v-no-right-click.js";
import vue3_toastify_zPoFw264mR from "/app/template1/plugins/vue3-toastify.js";
import gtm_client_OzmBuHLRIb from "/app/template1/plugins/gtm.client.ts";
import i18n_VfGcjrvSkj from "/app/template1/plugins/i18n.ts";
import scrollToTop_jnWzptp5jr from "/app/template1/plugins/scrollToTop.js";
import setDefaultCurrency_LJ6NWVgVzR from "/app/template1/plugins/setDefaultCurrency.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  nuxt_plugin_6wEQMY3tee,
  titles_m9SjywKgWm,
  defaults_SCHuOseEny,
  plugin_UC48QI1yOB,
  i18n_yfWm7jX06p,
  components_client_ZB1W0EeH0E,
  clickOutside_C8jIyDRU4O,
  v_no_right_click_FHwnEQbgDi,
  vue3_toastify_zPoFw264mR,
  gtm_client_OzmBuHLRIb,
  i18n_VfGcjrvSkj,
  scrollToTop_jnWzptp5jr,
  setDefaultCurrency_LJ6NWVgVzR
]